import React, { Component } from 'react';



class cai extends Component {
    // state = {

    // }
    // handleChange = (e) => {
    //     console.log(e);
    // }
    // handleSubmit = (e) => {
    //     console.log(e);
    // }
    render() {


        return (
            <section>

            <section className="container section">

            <h4 className="titleENG center">Cooking</h4>
                 
            <div className="row">
            <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img33/1.jpg" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">Spicy Crayfish</span>
            </div>
            </div>
        </div>

        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img33/2.jpg" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">Stewed Beef Brisket with Tomato</span>
            </div>
            </div>
        </div>

        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img33/3.jpg" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">Fried chicken chop</span>
            </div>
            </div>
        </div>

        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img33/4.jpg" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">Boiled Meatballs</span>
            </div>
            </div>
        </div>
        </div>     

              <div className="row">
            <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img33/5.jpg" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">Spicy Shrimp Ball</span>
            </div>
            </div>
        </div>

        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img33/6.jpg" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">Mapo Tofu</span>
            </div>
            </div>
        </div>

        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img33/7.jpg" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">Korean army stew</span>
            </div>
            </div>
        </div>

        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img33/8.jpg" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">Boiled fish</span>
            </div>
            </div>
        </div>
        </div>     

              <div className="row">
            <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img33/9.jpg" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">Candied sweet potatoes</span>
            </div>
            </div>
        </div>

        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img33/10.jpg" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">Sweet and sour pork ribs</span>
            </div>
            </div>
        </div>

        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img33/11.jpg" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">Braised pork trotters with soybeans</span>
            </div>
            </div>
        </div>

        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img33/12.jpg" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">Boiled Prawns</span>
            </div>
            </div>
        </div>
        </div>     

              <div className="row">
            <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img33/13.jpg" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">Chicken stewed with mushrooms</span>
            </div>
            </div>
        </div>

        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img33/14.jpg" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">Toothpick Beef</span>
            </div>
            </div>
        </div>

        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img33/15.jpg" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">Red Bean Rice Cake</span>
            </div>
            </div>
        </div>

        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img33/16.jpg" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">Enoki mushroom with garlic</span>
            </div>
            </div>
        </div>
        </div>     

              <div className="row">
            <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img33/17.jpg" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">Noodles with Soy Bean Paste</span>
            </div>
            </div>
        </div>

        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img33/18.jpg" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">Pineapple Sweet and Sour Pork</span>
            </div>
            </div>
        </div>

        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img33/19.jpg" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">Fried Pork in Scoop</span>
            </div>
            </div>
        </div>

        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img33/20.jpg" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">Coke Chicken Wings</span>
            </div>
            </div>
        </div>
        </div>     

              <div className="row">
            <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img33/21.jpg" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">Fried tofu</span>
            </div>
            </div>
        </div>

        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img33/22.jpg" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">Chicken curry</span>
            </div>
            </div>
        </div>

        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img33/23.jpg" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">Spicy fried potato shreds</span>
            </div>
            </div>
        </div>

        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img33/24.jpg" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">Yuxiang shredded pork</span>
            </div>
            </div>
        </div>
        </div>     

              <div className="row">
            <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img33/25.jpg" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">Kung Pao Diced Pork</span>
            </div>
            </div>
        </div>

        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img33/26.jpg" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">Spicy Fried Clams</span>
            </div>
            </div>
        </div>

        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img33/27.jpg" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">Shredded cabbage</span>
            </div>
            </div>
        </div>

        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img33/28.jpg" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">Shredded Pork with Vegetables</span>
            </div>
            </div>
        </div>
        </div>     

              <div className="row">
            <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img33/29.jpg" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">Fried Larimichthys crocea</span>
            </div>
            </div>
        </div>

        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img33/30.jpg" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">Ribs soup</span>
            </div>
            </div>
        </div>

        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img33/31.jpg" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">Fried shrimp balls</span>
            </div>
            </div>
        </div>

        <div className="col s12 m6 l3">
            <div className="card">
            <div className="card-image">
                <img src="../img33/32.jpg" alt="" className="responsive-img materialboxed"/>
                <span className="card-title">Popcorn chicken</span>
            </div>
            </div>
        </div>
        </div>     

  
            </section>
  
            </section>
        )
    }
}





export default cai
